import { isPlatform } from "@ionic/react";

export function AppHomeIndicatorBar() {
  const isIos = isPlatform("ios");

  return <>{isIos ? <div className="home-indicator-bar" /> : <div className="page-spacer-60" />}</>;
}
